import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "exhibitorCards"]

  connect() {
    // Pageshow handling is now managed by dashboard controller
  }

  disconnect() {
    if (this.pageshowHandler) {
      window.removeEventListener('pageshow', this.pageshowHandler)
    }
  }

  toggleFavorite(event) {
    const button = event.currentTarget
    const exhibitorId = button.dataset.exhibitorId
    const url = button.dataset.url
    
    button.disabled = true

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.getCSRFToken(),
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
      return response.json()
    })
    .then(data => {
      this.updateFavoriteButtons(exhibitorId, data.favorited)
    })
    .catch(error => {
      console.error('Could not update favorite.', error)
      this.showErrorToast('Failed to update favorite. Please try again.')
    })
    .finally(() => {
      button.disabled = false
    })
  }

  updateFavoriteButtons(exhibitorId, favorited) {
    // Get active filter from hidden field
    const filterField = document.querySelector('[data-attendee-dashboard-target="filterTypeField"]')
    const activeFilter = filterField?.value || 'all'

    this.buttonTargets.forEach(button => {
      if (button.dataset.exhibitorId === exhibitorId) {
        const icon = button.querySelector('i')
        if (!icon) return
        
        if (favorited) {
          button.classList.add('favorited')
          button.classList.remove('not-favorited')
          icon.classList.remove('bi-heart')
          icon.classList.add('bi-heart-fill')
        } else {
          button.classList.remove('favorited')
          button.classList.add('not-favorited')
          icon.classList.remove('bi-heart-fill')
          icon.classList.add('bi-heart')

          if (activeFilter === 'favorites') {
            const parentCol = button.closest('.col-12')
            if (parentCol) {
              this.fadeOutAndRemove(parentCol)
            }
          }
        }
      }
    })
  }

  fadeOutAndRemove(element) {
    if (!element) return
    
    element.style.transition = 'opacity 0.3s'
    element.style.opacity = '0'
    
    setTimeout(() => {
      element.remove()
      this.checkForEmptyExhibitorList()
    }, 300)
  }

  checkForEmptyExhibitorList() {
    const exhibitorCards = document.querySelector('.exhibitor-card')
    if (!exhibitorCards) return
    
    const remainingCards = exhibitorCards.querySelectorAll('.col-12').length || 0
    
    if (remainingCards === 0) {
      exhibitorCards.innerHTML = `
        <div class="col-12 text-center py-5">
          <i class="bi bi-building text-muted fs-1"></i>
          <h4 class="mt-3">No Exhibitors Found</h4>
          <p class="text-muted">There are no exhibitors available for this event.</p>
        </div>
      `
    }
  }

  showErrorToast(message) {
    // Remove existing error toasts
    document.querySelectorAll('.toast.bg-danger').forEach(toast => toast.remove())
    
    const toast = document.createElement('div')
    toast.className = 'toast align-items-center text-white bg-danger border-0 position-fixed top-0 end-0 m-3'
    toast.style.zIndex = '9999'
    toast.setAttribute('role', 'alert')
    
    toast.innerHTML = `
      <div class="d-flex">
        <div class="toast-body"></div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
      </div>
    `
    
    toast.querySelector('.toast-body').textContent = message
    
    document.body.appendChild(toast)
    
    const bsToast = new bootstrap.Toast(toast, { delay: 3000 })
    bsToast.show()
    
    toast.addEventListener('hidden.bs.toast', () => {
      toast.remove()
    })
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.getAttribute('content') : ''
  }
}
